import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getEmails = createAsyncThunk(
  "SendEmailAs/getEmails",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/users/send-email-as?pageNumber=${
          data.pageNumber || 1
        }&pageSize=${data.pageSize || 20}&sortBy=${
          data?.sortBy || ""
        }&sortOrder=${data.sortOrder || "desc"}&search=${data.search || ""}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
